document.addEventListener("DOMContentLoaded", () => {

const API="https://script.google.com/macros/s/AKfycbxkQvBRyp-gKJzGIaizHqNH4f2eRJBAruXfqrYtJYpkA0K2l7SL6hGrSZUra-pod8UvyA/exec";

const buscar=document.getElementById("buscarPedido");
const guardar=document.getElementById("guardarPedido");

buscar.addEventListener("click", async()=>{

const pedido=document.getElementById("pedido").value.trim();

const res=await fetch(API,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
action:"search",
pedido
})
});

const data=await res.json();

if(!data.success){
alert("Pedido no encontrado");
return;
}

document.getElementById("cliente").value=data.cliente;
document.getElementById("email").value=data.email;
document.getElementById("estado").value=data.estado;
document.getElementById("tracking").value=data.tracking;

});

guardar.addEventListener("click",async()=>{

const pedido=document.getElementById("pedido").value.trim();

const estado=document.getElementById("estado").value;

const tracking=document.getElementById("tracking").value;

await fetch(API,{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
action:"update",
pedido,
estado,
tracking
})
});

alert("Pedido actualizado correctamente");

});

});